import type { Bygg } from '@forvalter/types/ForvalterCommonDAL';
import type { IByggRequest, IByggResponse } from '../interfaces';

enum localStorageReferences {
    SELECTED_CONTEXT = 'storedSelectedContext',
    SHOW_BYGG_GRUNN = 'showByggGrunn',
}

enum contextSelectorActionsReferences {
    SAVE_BYGG_GRUNN = 'contextSelector/saveShowByggGrunnToStorage',
    SAVE_SELECTED_CONTEXT = 'contextSelector/saveSelectedContextToStorage',
    CLEAR_SELECTED_CONTEXT = 'contextSelector/clearSelectedContextFromStorage',
    SET_SELECTOR_FOCUS = 'contextSelector/setSelectorFocus',
    RESET_SELECTOR_FOCUS = 'contextSelector/resetSelectorFocus',
    SET_AND_RESET_SELECTOR_FOCUS = 'contextSelector/setAndResetSelectorFocus',
}

class ByggRequest implements IByggRequest {
    public navn?: IByggRequest['navn'];
    public id?: IByggRequest['id'];

    public constructor(params: IByggRequest) {
        Object.assign(this, params);
    }
}

class ByggResponse implements IByggResponse {
    public byggList: Array<Bygg>;
    public bygg: Bygg;

    public constructor(params: IByggResponse) {
        Object.assign(this, params);
    }
}

export {
    localStorageReferences,
    ByggRequest,
    ByggResponse,
    contextSelectorActionsReferences,
};
